/* eslint import/no-cycle: off */
import Vue from 'vue';
import Router from 'vue-router';
import qs from 'qs';
import apiService from '@/services/apiService';
import { i18n } from '@/i18n/i18n';
import { mode } from '@/utils/util';
import Role from '@/Role';
import usercomService from '@/services/usercomService';
import globalData from '@/store/globalData';

/* Layout */
import LayoutBlank from '@/layouts/Blank.vue';
import LayoutBasic from '@/layouts/Basic.vue';
import LayoutPanel from '@/layouts/Panel.vue';
// import LayoutTopNavigation from '@/layouts/LayoutTopNavigation.vue';
/* Layout */

/* Common */
import PageNotFound from '@/views/common/page-not-found/index.vue';
import PageForbidden from '@/views/common/page-forbidden/PageForbidden.vue';
import Login from '@/views/common/auth/login.vue';
import LoginAs from '@/views/common/login-as/index.vue';
import Register from '@/views/common/auth/register.vue';
import ResetPassword from '@/views/common/auth/reset-password.vue';
import ResetPasswordToken from '@/views/common/auth/reset-password-token.vue';
import AcceptTerms from '@/views/common/accept-terms/index.vue';
import ConfirmEmail from '@/views/common/confirm-email/index.vue';
import AccountSettings from '@/views/common/account/settings/index.vue';
import ReportsStats from '@/views/common/reports/stats/index.vue';
/* Common */

/* Widgeter */
import WidgeterEntryPage from '@/views/widgeter/entry-page/index.vue';
import WidgeterEntryPageBuyBoxAddWebsite from '@/views/widgeter/entry-page/buybox/add-website/index.vue';
import WidgeterEntryPageBuyBoxAccountReady from '@/views/widgeter/entry-page/buybox/account-ready/index.vue';
import WidgeterEntryPageTipBoxCompleteData from '@/views/widgeter/entry-page/tipbox/complete-data/index.vue';
import WidgeterEntryPageTipBoxAddWebsite from '@/views/widgeter/entry-page/tipbox/add-website/index.vue';
import WidgeterEntryPageTipBoxAccountReady from '@/views/widgeter/entry-page/tipbox/account-ready/index.vue';
import WidgeterDashboard from '@/views/widgeter/dashboard/index.vue';
import WidgeterWidgetGenerator from '@/views/widgeter/widget/generator/index.vue';
import WidgeterWidgetSettings from '@/views/widgeter/widget/settings/index.vue';
import WidgeterWidgetSettingsEdit, { TABS as WIDGETER_WIDGET_SETTINGS_EDIT_TABS } from '@/views/widgeter/widget/settings/_id/index.vue';
import WidgeterWidgetSettingsEditTabAppearance from '@/views/widgeter/widget/settings/_id/_tab/appearance/index.vue';
import WidgeterWidgetSettingsEditTabCampaigns from '@/views/widgeter/widget/settings/_id/_tab/campaigns/index.vue';
import WidgeterTextLinks from '@/views/widgeter/text-links/index.vue';
import WidgeterProductLandingPageGenerator from '@/views/widgeter/product-landing-page/generator/index.vue';
import WidgeterProductLandingPageSettings from '@/views/widgeter/product-landing-page/settings/index.vue';
import WidgeterProductLandingPageSettingsEdit from '@/views/widgeter/product-landing-page/settings/_id/index.vue';
import WidgeterReportsShops from '@/views/widgeter/reports/shops/index.vue';
import WidgeterReportsPages from '@/views/widgeter/reports/pages/index.vue';
import WidgeterReportsProducts from '@/views/widgeter/reports/products/index.vue';
import WidgeterReportsTransactions from '@/views/widgeter/reports/transactions/index.vue';
import WidgeterPages from '@/views/widgeter/pages/index.vue';
import WidgeterShops from '@/views/widgeter/shops/index.vue';
import WidgeterSettingsIntegrations from '@/views/widgeter/settings/integrations/index.vue';
import WidgeterSettingsApi from '@/views/widgeter/settings/api/index.vue';
import WidgeterSettingsWebhooks from '@/views/widgeter/settings/webhooks/index.vue';
import WidgeterSettingsWebhooksTipbox from '@/views/widgeter/settings/webhooks-tipbox/index.vue';
import WidgeterWidgetPreview from '@/views/widgeter/widget-preview/index.vue';
import WidgeterFinance from '@/views/widgeter/finance/index.vue';
import WidgeterPaymentGeneratorCompany from '@/views/widgeter/finance/parts/PaymentGeneratorCompany.vue';
import WidgeterBBAffiliateProgram from '@/views/widgeter/bb-affiliate-program/index.vue';
import WidgeterTipboxTips from '@/views/widgeter/tipbox/tips/index.vue';
import WidgeterTipboxSettlements from '@/views/widgeter/tipbox/settlements/index.vue';
import WidgeterTipboxSettings from '@/views/widgeter/tipbox/settings/index.vue';
import WidgeterTipboxSettingsEdit from '@/views/widgeter/tipbox/settings/_id/index.vue';
import WidgeterTipboxLink from '@/views/widgeter/tipbox/link/index.vue';
import WidgeterTipboxLinkEdit from '@/views/widgeter/tipbox/link/_id/index.vue';
/* Widgeter */

/* Advertiser */
import AdvertiserWebpagesList from '@/views/advertiser/webpages/index.vue';
import AdvertiserDashboard from '@/views/advertiser/dashboard/index.vue';
import AdvertiserReportsTransactions from '@/views/advertiser/reports/transactions/index.vue';
import AdvertiserReportsPages from '@/views/advertiser/reports/pages/index.vue';
import AdvertiserSettingsShopPresentation from '@/views/advertiser/settings/shop-presentation/index.vue';
import AdvertiserApi from '@/views/advertiser/api/index.vue';
import AdvertiserOffersCatalog from '@/views/advertiser/offers-catalog/index.vue';
import AdvertiserOffersCatalogProductList from '@/views/advertiser/offers-catalog/ProductList.vue';
import AdvertiserOffersCatalogProductDetails from '@/views/advertiser/offers-catalog/_id/ProductDetails.vue';
/* Advertiser */

/* Producer */
import ProducerDashboard from '@/views/producer/dashboard/index.vue';
import ProducerProductGroups from '@/views/producer/product-groups/index.vue';
import ProducerProductGroupsEdit from '@/views/producer/product-groups/_id/index.vue';
import ProducerProductCatalog from '@/views/producer/product-catalog/index.vue';
import ProducerReportsShops from '@/views/producer/reports/shops/index.vue';
import ProducerReportsCategories from '@/views/producer/reports/categories/index.vue';
import ProducerReportsProducts from '@/views/producer/reports/products/index.vue';
import ProducerReportsAvailability from '@/views/producer/reports/availability/index.vue';
import ProducerReportsPriceDistribution from '@/views/producer/reports/price-distribution/index.vue';
import ProducerReportsSales from '@/views/producer/reports/sales/index.vue';
import ProducerCompetitiveAnalysis from '@/views/producer/competitive-analysis/index.vue';
import ProducerPlugin from '@/views/producer/plugin/index.vue';
import ProducerSettingsSpaces from '@/views/producer/settings/spaces/index.vue';
import ProducerSettingsSubscriptions from '@/views/producer/settings/subscriptions/index.vue';
import ProducerSettingsWebhooks from '@/views/producer/settings/webhooks/index.vue';
import ProducerDataExport from '@/views/producer/data-export/index.vue';
import ProducerAccountSettings from '@/views/producer/account/settings/index.vue';
/* Producer */

/* Admin */
import AdminLogin from '@/views/admin/auth/index.vue';
import AdminDashboard from '@/views/admin/dashboard/index.vue';
import AdminReportsTransactions from '@/views/admin/reports/transactions/index.vue';
import AdminReportsConversion from '@/views/admin/reports/conversion/index.vue';
import AdminReportsIntegrationStatus from '@/views/admin/reports/integration-status/index.vue';
import AdminFeedImportSummary from '@/views/admin/reports/feed-import-summary/index.vue';
import AdminReportsWidgetVersionChart from '@/views/admin/reports/page-versions/index.vue';
import AdminCatalogProducts from '@/views/admin/catalog/products/index.vue';
import AdminCatalogProductsDetails from '@/views/admin/catalog/products/_id/index.vue';
import AdminCatalogManufacturers from '@/views/admin/catalog/manufacturers/index.vue';
import AdminCatalogBrands from '@/views/admin/catalog/brands/index.vue';
import AdminCatalogCategories from '@/views/admin/catalog/categories/index.vue';
import AdminCatalogProductVariants from '@/views/admin/catalog/product-variants/index.vue';
import AdminCatalogProductVariantsDetails from '@/views/admin/catalog/product-variants/_id/index.vue';
import AdminUsers from '@/views/admin/users/index.vue';
import AdminUsersDetails from '@/views/admin/users/_id/index.vue';
import AdminWebpagesList from '@/views/admin/webpages/list/index.vue';
import AdminWebpagesDetails from '@/views/admin/webpages/list/_id/index.vue';
import AdminOffers from '@/views/admin/offers/index.vue';
import AdminOffersDetails from '@/views/admin/offers/_id/index.vue';
import AdminTipboxTips from '@/views/admin/tipbox/tips/index.vue';
import AdminTipboxVerification from '@/views/admin/tipbox/verification/index.vue';
import AdminTipboxSettlements from '@/views/admin/tipbox/settlements/index.vue';
import AdminCampaignsList from '@/views/admin/campaigns/list/index.vue';
import AdminCampaignsDetails, { TABS as ADMIN_CAMPAIGNS_DETAILS_TABS } from '@/views/admin/campaigns/list/_id/index.vue';
import AdminCampaignsDetailsTabSettings from '@/views/admin/campaigns/list/_id/_tab/settings/index.vue';
import AdminCampaignsDetailsTabCategories from '@/views/admin/campaigns/list/_id/_tab/categories/index.vue';
import AdminCampaignsDetailsTabCommissions from '@/views/admin/campaigns/list/_id/_tab/commissions/index.vue';
import AdminCampaignsDetailsTabOfflineLocations from '@/views/admin/campaigns/list/_id/_tab/offline-locations/index.vue';
import AdminCampaignsDetailsTabFeeds from '@/views/admin/campaigns/list/_id/_tab/feeds/index.vue';
import AdminCampaignsDetailsTabFeedsIndex from '@/views/admin/campaigns/list/_id/_tab/feeds/view.vue';
import AdminCampaignsDetailsTabFeedsEdit from '@/views/admin/campaigns/list/_id/_tab/feeds/edit.vue';
import AdminProducerProductsImport from '@/views/admin/producer-products/import/index.vue';
import AdminProducerProductsProducts from '@/views/admin/producer-products/products/index.vue';
import AdminProducerProductsProductsDetails from '@/views/admin/producer-products/products/_id/index.vue';
import AdminSettlementsReport from '@/views/admin/settlements/report/index.vue';
import AdminSettlementsInvoices from '@/views/admin/settlements/invoices/index.vue';
import AdminSettlementsInvoicesDetails from '@/views/admin/settlements/invoices/_id/index.vue';
import AdminSettlementsInvoicesCreate from '@/views/admin/settlements/invoices/_id/create.vue';
import AdminProducts from '@/views/admin/products/index.vue';
import AdminProductsItemShow from '@/views/admin/products/_id/show.vue';
import AdminProductsItemAudit from '@/views/admin/products/_id/audit.vue';
import AdminTransactionsImport from '@/views/admin/transactions/import/index.vue';
import AdminTransactionsValidation from '@/views/admin/transactions/validation/index.vue';
import AdminTransactionsCorrection from '@/views/admin/transactions/correction/index.vue';
import AdminFinanceSubscriptions from '@/views/admin/finance/subscriptions/index.vue';
import AdminFinanceSubscriptionsCreate from '@/views/admin/finance/subscriptions/create.vue';
import AdminFinanceSettlementsPublishers from '@/views/admin/finance/settlements/publishers/index.vue';
import AdminCatalogImportModeration from '@/views/admin/catalog/import-moderation/index.vue';
import AdminCatalogImportModerationDetails from '@/views/admin/catalog/import-moderation/_id/index.vue';
import AdminCatalogAggregateModeration from '@/views/admin/catalog/aggregate-moderation/index.vue';
import AdminCatalogAggregateModerationDetails from '@/views/admin/catalog/aggregate-moderation/_id/index.vue';
import AdminCatalogOffersModeration from '@/views/admin/catalog/offers-moderation/index.vue';
import AdminCatalogOffersModerationDetails from '@/views/admin/catalog/offers-moderation/_id/index.vue';
/* Admin */

import hasFeatureGuard from './guards/hasFeatureGuard';
import hasAccessGuard from './guards/hasAccessGuard';

Vue.use(Router);

const routes = [
    {
        path: '/login-as/:token?',
        name: 'LoginAs',
        component: LoginAs,
        props: route => ({
            token: route.params.token,
            isAdmin: true,
        }),
        meta: {
            title: 'loginAs.title',
        },
    },
    {
        path: '/redirect-login/:token?',
        name: 'LoginRedirect',
        component: LoginAs,
        props: route => ({
            token: route.params.token,
            isAdmin: false,
        }),
        meta: {
            title: 'loginAs.title',
        },
    },
    ...(mode === 'ADMIN'
        ? [
              {
                  path: '/login',
                  name: 'Login',
                  component: AdminLogin,
                  meta: {
                      title: 'login.title',
                      isGuest: true,
                  },
              },
          ]
        : []),
    {
        path: '',
        name: 'LayoutAuth',
        component: LayoutBlank,
        redirect: { name: 'Login' },
        meta: {
            isGuest: true,
        },
        children: [
            ...(mode === 'WIDGETER' || mode === 'ADVERTISER' || mode === 'PRODUCER'
                ? [
                      {
                          path: '/login',
                          name: 'Login',
                          component: Login,
                          meta: {
                              title: 'login.title',
                          },
                      },
                  ]
                : []),
            {
                path: '/register',
                name: 'Register',
                component: Register,
                meta: {
                    title: 'auth.pageRegister.pageTitle',
                },
            },
            {
                path: '/reset-password',
                name: 'ResetPassword',
                component: ResetPassword,
                meta: {
                    title: 'resetPassword.title',
                },
            },
            {
                path: '/reset-password/:token',
                name: 'ResetPasswordToken',
                component: ResetPasswordToken,
                props: true,
                meta: {
                    title: 'pageResetPasswordToken.title',
                },
            },
        ],
    },
    {
        path: '/:role',
        component: LayoutBasic,
        redirect: { name: 'Dashboard' },
        props: { centered: true },
        children: [
            {
                path: 'entry-page',
                name: 'EntryPage',
                beforeEnter: (to, from, next) => {
                    const spaceCount = globalData.spaceCount;
                    const isRoleWidgeter = globalData.user?.isRoleWidgeter;
                    if (!isRoleWidgeter) {
                        return next({ name: 'Dashboard' });
                    }
                    if (isRoleWidgeter && spaceCount) {
                        return next({ name: 'Dashboard' });
                    }
                    return next();
                },
                component: Vue.component('LayoutWidgeterEntryPage', {
                    render: function render(h) {
                        if (this.$route.name === 'EntryPage') return h(WidgeterEntryPage);
                        return h(LayoutBlank);
                    },
                }),
                meta: {
                    isSecure: true,
                    title: 'entrypage.title',
                    roles: [Role.WIDGETER],
                },
                children: [
                    {
                        path: 'buybox',
                        name: 'EntryPageBuyBox',
                        component: LayoutBlank,
                        meta: {
                            title: 'buybox',
                            roles: [Role.WIDGETER],
                        },
                        redirect: { name: 'EntryPageBuyBoxAddWebsite' },
                        children: [
                            {
                                path: 'add-website',
                                name: 'EntryPageBuyBoxAddWebsite',
                                component: WidgeterEntryPageBuyBoxAddWebsite,
                                meta: {
                                    title: 'buybox',
                                    roles: [Role.WIDGETER],
                                },
                            },
                            {
                                path: 'account-ready',
                                name: 'EntryPageBuyBoxAccountReady',
                                component: WidgeterEntryPageBuyBoxAccountReady,
                                meta: {
                                    title: 'buybox',
                                    roles: [Role.WIDGETER],
                                },
                            },
                        ],
                    },
                    {
                        path: 'tipbox',
                        name: 'EntryPageTipBox',
                        component: LayoutBlank,
                        meta: {
                            title: 'tipbox',
                            roles: [Role.WIDGETER],
                        },
                        redirect: { name: 'EntryPageTipBoxCompleteData' },
                        children: [
                            {
                                path: 'complete-data',
                                name: 'EntryPageTipBoxCompleteData',
                                component: WidgeterEntryPageTipBoxCompleteData,
                                beforeEnter: (to, from, next) => {
                                    const tipboxSettings = globalData.tipboxSettings;
                                    const isActive = tipboxSettings?.policies && tipboxSettings.paymentDataCompleted;
                                    if (!isActive) return next();
                                    return next({ name: 'EntryPageTipBoxAddWebsite' });
                                },
                                meta: {
                                    title: 'tipbox',
                                    roles: [Role.WIDGETER],
                                },
                            },
                            {
                                path: 'add-website',
                                name: 'EntryPageTipBoxAddWebsite',
                                component: WidgeterEntryPageTipBoxAddWebsite,
                                meta: {
                                    title: 'tipbox',
                                    roles: [Role.WIDGETER],
                                },
                            },
                            {
                                path: 'account-ready',
                                name: 'EntryPageTipBoxAccountReady',
                                component: WidgeterEntryPageTipBoxAccountReady,
                                meta: {
                                    title: 'tipbox',
                                    roles: [Role.WIDGETER],
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        path: '',
        name: 'LayoutBasic',
        component: LayoutBasic,
        children: [
            {
                path: '/accept-terms',
                name: 'AcceptTerms',
                component: AcceptTerms,
                meta: {
                    title: 'acceptTerms.title',
                    isSecure: true,
                },
            },
            {
                path: '/confirm-email/:token?',
                name: 'ConfirmEmail',
                component: ConfirmEmail,
                props: true,
                meta: {
                    title: 'confirmEmail.title',
                },
            },
        ],
    },
    {
        path: '/:role/widget-preview',
        name: 'WidgetPreview',
        component: Vue.component('WidgetPreviewPage', {
            render: function render(h) {
                if (globalData.user.isRoleWidgeter) return h(WidgeterWidgetPreview);
                return h(LayoutBlank);
            },
        }),
        meta: {
            isSecure: true,
            title: 'widgetPreview.pageTitle',
            roles: [Role.WIDGETER],
        },
    },
    {
        path: '/:role',
        name: 'LayoutPanel',
        component: LayoutPanel,
        redirect: { name: 'Dashboard' },
        meta: {
            isSecure: true,
        },
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: Vue.component('UserDashboard', {
                    render: function render(h) {
                        if (globalData.user.isRoleAdmin) return h(AdminDashboard);
                        if (globalData.user.isRoleWidgeter) return h(WidgeterDashboard);
                        if (globalData.user.isRoleAdvertiser) return h(AdvertiserDashboard);
                        if (globalData.user.isRoleProducer) return h(ProducerDashboard);
                        return h(LayoutBlank);
                    },
                }),
                meta: {
                    title: 'dashboard.title',
                    roles: [Role.ADMIN, Role.SUPERADMIN, Role.WIDGETER, Role.ADVERTISER, Role.PRODUCER],
                },
            },
            {
                path: 'widget',
                name: 'Widget',
                component: LayoutBlank,
                redirect: {
                    name: 'WidgetSettings',
                },
                children: [
                    {
                        path: 'generator',
                        name: 'WidgetGenerator',
                        component: WidgeterWidgetGenerator,
                        meta: {
                            title: 'generator.title',
                            roles: [Role.WIDGETER],
                        },
                    },
                    {
                        path: 'settings',
                        name: 'WidgetSettings',
                        component: Vue.component('UserWidgetSettings', {
                            render: function render(h) {
                                if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                                return h(WidgeterWidgetSettings);
                            },
                        }),
                        meta: {
                            title: 'configurations',
                            roles: [Role.WIDGETER],
                        },
                        children: [
                            {
                                path: ':id(\\d+)',
                                name: 'WidgetSettingsEdit',
                                beforeEnter: (to, from, next) => {
                                    const tab = WIDGETER_WIDGET_SETTINGS_EDIT_TABS.includes(to.params.tab) ? to.params.tab : WIDGETER_WIDGET_SETTINGS_EDIT_TABS[0];
                                    const query = to.query;
                                    const params = { ...to.params, tab };
                                    if (to.name === 'WidgetSettingsEditTab') return next({ query, params });
                                    return next({ name: 'WidgetSettingsEditTab', query, params });
                                },
                                component: WidgeterWidgetSettingsEdit,
                                meta: {
                                    title: 'widgetSettings.title',
                                    roles: [Role.WIDGETER],
                                },
                                children: [
                                    {
                                        path: ':tab',
                                        name: 'WidgetSettingsEditTab',
                                        components: {
                                            appearance: WidgeterWidgetSettingsEditTabAppearance,
                                            campaigns: WidgeterWidgetSettingsEditTabCampaigns,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'text-links',
                name: 'TextLinks',
                component: WidgeterTextLinks,
                meta: {
                    title: 'textLinks.title',
                    roles: [Role.WIDGETER],
                },
            },
            {
                path: 'product-landing-page',
                name: 'ProductLandingPage',
                component: LayoutBlank,
                redirect: {
                    name: 'ProductLandingPageGenerator',
                },
                meta: {
                    title: 'productLandingPage.title',
                    roles: [Role.WIDGETER],
                },
                children: [
                    {
                        path: 'generator',
                        name: 'ProductLandingPageGenerator',
                        component: WidgeterProductLandingPageGenerator,
                        meta: {
                            title: 'productLandingPageGenerator.title',
                            roles: [Role.WIDGETER],
                        },
                    },
                    {
                        path: 'settings',
                        component: LayoutBlank,
                        redirect: {
                            name: 'ProductLandingPageSettings',
                        },
                        children: [
                            {
                                path: '',
                                name: 'ProductLandingPageSettings',
                                component: Vue.component('UserProductLandingPageSettings', {
                                    render: function render(h) {
                                        if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                                        return h(WidgeterProductLandingPageSettings);
                                    },
                                }),
                                meta: {
                                    title: 'productLandingPageSettings.title',
                                    roles: [Role.WIDGETER],
                                },
                                children: [
                                    {
                                        path: ':id(\\d+)',
                                        name: 'ProductLandingPageSettingsEdit',
                                        component: WidgeterProductLandingPageSettingsEdit,
                                        meta: {
                                            title: 'productLandingPageSettings.title',
                                            roles: [Role.WIDGETER],
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'reports',
                name: 'Reports',
                component: LayoutBlank,
                redirect: {
                    name: 'ReportsStats',
                },
                children: [
                    {
                        path: 'stats',
                        name: 'ReportsStats',
                        component: ReportsStats,
                        meta: {
                            title: 'statistics',
                            roles: [Role.WIDGETER, Role.ADVERTISER, Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'transactions',
                        name: 'ReportsTransactions',
                        component: Vue.component('UserReportsTransactions', {
                            render: function render(h) {
                                if (globalData.user.isRoleWidgeter) return h(WidgeterReportsTransactions);
                                if (globalData.user.isRoleAdvertiser) return h(AdvertiserReportsTransactions);
                                if (globalData.user.isRoleAdmin) return h(AdminReportsTransactions);
                                return h(LayoutBlank);
                            },
                        }),
                        props: route => ({ query: route.query }),
                        meta: {
                            title: 'transactions.title',
                            roles: [Role.WIDGETER, Role.ADVERTISER, Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'pages',
                        name: 'ReportsPages',
                        component: Vue.component('UserReportsPages', {
                            render: function render(h) {
                                if (globalData.user.isRoleWidgeter) return h(WidgeterReportsPages);
                                if (globalData.user.isRoleAdvertiser) return h(AdvertiserReportsPages);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'reportsPages.title',
                            roles: [Role.WIDGETER, Role.ADVERTISER],
                        },
                    },
                    {
                        path: 'shops',
                        name: 'ReportsShops',
                        component: Vue.component('UserReportsShops', {
                            render: function render(h) {
                                if (globalData.user.isRoleWidgeter) return h(WidgeterReportsShops);
                                if (globalData.user.isRoleProducer) return h(ProducerReportsShops);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'reportsShops.title',
                            roles: [Role.WIDGETER, Role.PRODUCER],
                        },
                    },
                    {
                        path: 'products',
                        name: 'ReportsProducts',
                        component: Vue.component('UserReportsProducts', {
                            render: function render(h) {
                                if (globalData.user.isRoleWidgeter) return h(WidgeterReportsProducts);
                                if (globalData.user.isRoleProducer) return h(ProducerReportsProducts);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'reportsProductsTitle',
                            roles: [Role.WIDGETER, Role.PRODUCER],
                        },
                    },
                    {
                        path: 'conversion',
                        name: 'ReportsConversion',
                        component: AdminReportsConversion,
                        meta: {
                            title: 'conversionReport',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'integration-status',
                        name: 'ReportsIntegrationStatus',
                        component: AdminReportsIntegrationStatus,
                        meta: {
                            title: 'integrationStatus',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'feed-import-summary',
                        name: 'ReportsFeedImportSummary',
                        component: AdminFeedImportSummary,
                        meta: {
                            title: 'feedImportSummary',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'page-versions',
                        name: 'ReportsWidgetVersionChart',
                        component: AdminReportsWidgetVersionChart,
                        meta: {
                            title: 'widgetVersionReport',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'categories',
                        name: 'ReportsCategories',
                        component: ProducerReportsCategories,
                        meta: {
                            title: 'sidebar.categories',
                            roles: [Role.PRODUCER],
                        },
                    },
                    {
                        path: 'availability',
                        name: 'ReportsAvailability',
                        component: ProducerReportsAvailability,
                        meta: {
                            title: 'sidebar.availability',
                            roles: [Role.PRODUCER],
                        },
                    },
                    {
                        path: 'price-distribution',
                        name: 'ReportsPriceDistribution',
                        component: ProducerReportsPriceDistribution,
                        meta: {
                            title: 'sidebar.priceDistribution',
                            roles: [Role.PRODUCER],
                        },
                    },
                    {
                        path: 'sales',
                        name: 'ReportsSales',
                        component: ProducerReportsSales,
                        meta: {
                            title: 'sidebar.sales',
                            roles: [Role.PRODUCER],
                        },
                    },
                ],
            },
            {
                path: 'pages',
                name: 'Pages',
                component: WidgeterPages,
                meta: {
                    title: 'pages.title',
                    roles: [Role.WIDGETER],
                },
            },
            {
                path: 'shops',
                name: 'Shops',
                component: WidgeterShops,
                meta: {
                    title: 'widgeterShops.title',
                    roles: [Role.WIDGETER],
                },
            },
            {
                path: 'finance',
                name: 'Finance',
                component: Vue.component('UserFinance', {
                    render: function render(h) {
                        if (globalData.user.isRoleWidgeter) return h(WidgeterFinance);
                        if (globalData.user.isRoleAdmin && this.$route.name === 'Finance') return this.$router.replace({ name: 'FinanceSubscriptions' }); // redirect to children
                        return h(LayoutBlank);
                    },
                }),
                meta: {
                    title: 'finance.title',
                    roles: [Role.WIDGETER, Role.ADMIN, Role.SUPERADMIN],
                },
                children: [
                    {
                        path: 'subscriptions',
                        name: 'FinanceSubscriptions',
                        component: Vue.component('UserFinanceSubscriptions', {
                            render: function render(h) {
                                if (this.$route.name === 'FinanceSubscriptions') return h(AdminFinanceSubscriptions);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'subscriptions',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                        children: [
                            {
                                path: 'create',
                                name: 'FinanceSubscriptionsCreate',
                                component: AdminFinanceSubscriptionsCreate,
                                meta: {
                                    title: 'createSubscription',
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'finance/payment',
                name: 'PaymentGenerator',
                component: WidgeterPaymentGeneratorCompany,
                meta: {
                    title: 'paymentGeneratorCompany.title',
                    roles: [Role.WIDGETER],
                },
            },
            {
                path: 'settings',
                name: 'Settings',
                component: LayoutBlank,
                redirect: {
                    name: 'SettingsApi',
                },
                children: [
                    {
                        path: 'api',
                        name: 'SettingsApi',
                        component: WidgeterSettingsApi,
                        meta: {
                            title: 'api.title',
                            roles: [Role.WIDGETER],
                        },
                    },
                    {
                        path: 'integrations',
                        name: 'SettingsIntegrations',
                        component: WidgeterSettingsIntegrations,
                        meta: {
                            title: 'widgeterSettingsIntegrations.title',
                            roles: [Role.WIDGETER],
                        },
                    },
                    {
                        path: 'webhooks',
                        name: 'SettingsWebhooks',
                        component: Vue.component('UserSettingsWebhooks', {
                            render: function render(h) {
                                if (globalData.user.isRoleWidgeter) return h(WidgeterSettingsWebhooks);
                                if (globalData.user.isRoleProducer) return h(ProducerSettingsWebhooks);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'webhook',
                            roles: [Role.WIDGETER, Role.PRODUCER],
                        },
                    },
                    {
                        path: 'webhooks-tipbox',
                        name: 'SettingsWebhooksTipbox',
                        component: Vue.component('UserSettingsWebhooksTipbox', {
                            render: function render(h) {
                                if (globalData.user.isRoleWidgeter) return h(WidgeterSettingsWebhooksTipbox);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'webhookTipbox',
                            roles: [Role.WIDGETER],
                            feature: 'tipbox',
                        },
                    },
                    {
                        path: 'shop-presentation',
                        name: 'SettingsShopPresentation',
                        component: AdvertiserSettingsShopPresentation,
                        meta: {
                            title: 'shopPresentation',
                            roles: [Role.ADVERTISER],
                        },
                    },
                    {
                        path: 'spaces',
                        name: 'SettingsSpaces',
                        component: ProducerSettingsSpaces,
                        meta: {
                            title: 'sidebar.yourWebsites',
                            roles: [Role.PRODUCER],
                        },
                    },
                    {
                        path: 'subscriptions',
                        name: 'SettingsSubscriptions',
                        component: ProducerSettingsSubscriptions,
                        meta: {
                            title: 'sidebar.subscriptions',
                            roles: [Role.PRODUCER],
                        },
                    },
                ],
            },
            {
                path: 'account',
                name: 'Account',
                component: LayoutBlank,
                redirect: {
                    name: 'AccountSettings',
                },
                children: [
                    {
                        path: 'settings',
                        name: 'AccountSettings',
                        component: Vue.component('UserAccountSettings', {
                            render: function render(h) {
                                if (globalData.user.isRoleWidgeter || globalData.user.isRoleAdvertiser) return h(AccountSettings);
                                if (globalData.user.isRoleProducer) return h(ProducerAccountSettings);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'accountSettings.title',
                            roles: [Role.WIDGETER, Role.ADVERTISER, Role.PRODUCER],
                        },
                    },
                ],
            },
            {
                path: 'webpages',
                name: 'Webpages',
                component: Vue.component('UserWebpages', {
                    render: function render(h) {
                        if (globalData.user.isRoleAdvertiser) return h(AdvertiserWebpagesList);
                        if (this.$route.name === 'Webpages') return this.$router.replace({ name: 'WebpagesList' }); // redirect to children
                        return h(LayoutBlank);
                    },
                }),
                meta: {
                    title: 'webpagesPublishers',
                    roles: [Role.ADVERTISER, Role.ADMIN, Role.SUPERADMIN],
                },
                children: [
                    {
                        path: 'list',
                        name: 'WebpagesList',
                        component: Vue.component('UserWebpagesList', {
                            render: function render(h) {
                                if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                                if (globalData.user.isRoleAdmin) return h(AdminWebpagesList);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'pagesList',
                            roles: [Role.ADVERTISER, Role.ADMIN, Role.SUPERADMIN],
                        },
                        children: [
                            {
                                path: ':id(\\d+):sep(-)?:slug(.*)?',
                                name: 'WebpagesDetails',
                                component: Vue.component('UserWebpagesDetails', {
                                    render: function render(h) {
                                        if (globalData.user.isRoleAdmin) return h(AdminWebpagesDetails);
                                        return h(LayoutBlank);
                                    },
                                }),
                                meta: {
                                    title: 'pagesDetails',
                                    roles: [Role.ADVERTISER, Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'campaigns',
                name: 'Campaigns',
                component: LayoutBlank,
                redirect: { name: 'CampaignsList' },
                meta: {
                    title: 'campaigns',
                    roles: [Role.ADMIN, Role.SUPERADMIN],
                },
                children: [
                    {
                        path: 'list',
                        name: 'CampaignsList',
                        component: Vue.component('UserCampaignsList', {
                            render: function render(h) {
                                if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                                if (this.$route.params.id === 'add') return h(LayoutBlank);
                                if (globalData.user.isRoleAdmin) return h(AdminCampaignsList);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'campaignsList',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                        children: [
                            {
                                path: ':id(\\d+|add)',
                                name: 'CampaignsDetails',
                                beforeEnter: (to, from, next) => {
                                    if (!ADMIN_CAMPAIGNS_DETAILS_TABS.includes(to.params.tab)) {
                                        return next({ name: 'CampaignsDetailsTabIndex', query: to.query, params: { ...to.params, tab: ADMIN_CAMPAIGNS_DETAILS_TABS[0] } });
                                    }
                                    return next();
                                },
                                component: Vue.component('UserCampaignsDetails', {
                                    render: function render(h) {
                                        if (globalData.user.isRoleAdmin) return h(AdminCampaignsDetails);
                                        return h(LayoutBlank);
                                    },
                                }),
                                meta: {
                                    title: 'pagesDetails',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                                children: [
                                    {
                                        path: ':tab',
                                        components: {
                                            settings: AdminCampaignsDetailsTabSettings,
                                            categories: AdminCampaignsDetailsTabCategories,
                                            commissions: AdminCampaignsDetailsTabCommissions,
                                            feeds: AdminCampaignsDetailsTabFeeds,
                                            'offline-locations': AdminCampaignsDetailsTabOfflineLocations,
                                        },
                                        children: [
                                            {
                                                path: '',
                                                name: 'CampaignsDetailsTabIndex',
                                                components: {
                                                    feed: AdminCampaignsDetailsTabFeedsIndex,
                                                },
                                            },
                                            {
                                                path: 'create',
                                                name: 'CampaignsDetailsTabCreate',
                                                components: {
                                                    feed: AdminCampaignsDetailsTabFeedsEdit,
                                                },
                                            },
                                            {
                                                path: ':itemId(\\d+)/edit',
                                                name: 'CampaignsDetailsTabEdit',
                                                components: {
                                                    feed: AdminCampaignsDetailsTabFeedsEdit,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'settlements',
                name: 'Settlements',
                redirect: { name: 'SettlementsReport' },
                component: LayoutBlank,
                meta: {
                    title: 'settlements',
                    roles: [Role.ADMIN, Role.SUPERADMIN],
                },
                children: [
                    {
                        path: 'report',
                        name: 'SettlementsReport',
                        component: AdminSettlementsReport,
                        meta: {
                            title: 'settlements',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'invoices',
                        name: 'SettlementsInvoices',
                        component: Vue.component('UserSettlementsInvoices', {
                            render: function render(h) {
                                if (this.$route.name === 'SettlementsInvoices') return h(AdminSettlementsInvoices);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'settlements',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                        children: [
                            {
                                path: 'create',
                                name: 'SettlementsInvoicesCreate',
                                component: AdminSettlementsInvoicesCreate,
                                meta: {
                                    title: 'settlements',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                            {
                                path: ':id',
                                name: 'SettlementsInvoicesDetails',
                                component: AdminSettlementsInvoicesDetails,
                                meta: {
                                    title: 'settlements',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'api',
                name: 'Api',
                component: AdvertiserApi,
                meta: {
                    title: 'api.title',
                    roles: [Role.ADVERTISER],
                },
            },
            {
                path: 'offers-catalog',
                name: 'OffersCatalog',
                component: AdvertiserOffersCatalog,
                redirect: { name: 'OffersCatalogProductList' },
                meta: {
                    title: 'offersCatalog',
                    roles: [Role.ADVERTISER],
                },
                children: [
                    {
                        path: '',
                        name: 'OffersCatalogProductList',
                        component: AdvertiserOffersCatalogProductList,
                        meta: {
                            title: 'offersCatalog',
                            roles: [Role.ADVERTISER],
                        },
                    },
                    {
                        path: ':id(\\d+):sep(-)?:slug(.*)?',
                        name: 'OffersCatalogProductDetails',
                        component: AdvertiserOffersCatalogProductDetails,
                        meta: {
                            title: 'offersCatalog',
                            roles: [Role.ADVERTISER],
                        },
                    },
                ],
            },
            {
                path: 'catalog',
                name: 'Catalog',
                component: LayoutBlank,
                redirect: {
                    name: 'CatalogProducts',
                },
                children: [
                    {
                        path: 'products',
                        name: 'CatalogProducts',
                        component: Vue.component('UserCatalogProducts', {
                            render(h) {
                                if (this.$route.params.id) return h(LayoutBlank);
                                return h(AdminCatalogProducts);
                            },
                        }),
                        meta: {
                            title: 'catalogProductsTitle',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                        children: [
                            {
                                path: ':id',
                                name: 'CatalogProductsDetails',
                                component: AdminCatalogProductsDetails,
                                meta: {
                                    title: 'catalogProductsTitle',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                        ],
                    },
                    {
                        path: 'manufacturers',
                        name: 'CatalogManufacturers',
                        component: AdminCatalogManufacturers,
                        meta: {
                            title: 'catalogManufacturersTitle',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'brands',
                        name: 'CatalogBrands',
                        component: AdminCatalogBrands,
                        meta: {
                            title: 'catalogBrandsTitle',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'categories',
                        name: 'CatalogCategories',
                        component: AdminCatalogCategories,
                        meta: {
                            title: 'catalogCategoriesTitle',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'product-variants',
                        name: 'CatalogProductVariants',
                        component: Vue.component('UserCatalogProductVariants', {
                            render: function render(h) {
                                if (this.$route.params.id) return h(LayoutBlank);
                                if (globalData.user.isRoleAdmin) return h(AdminCatalogProductVariants);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'productVariants',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                        children: [
                            {
                                path: ':id',
                                name: 'CatalogProductVariantsDetails',
                                component: AdminCatalogProductVariantsDetails,
                                meta: {
                                    title: 'productDetails',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                        ],
                    },
                    {
                        path: 'aggregate-moderation',
                        name: 'AggregateModeration',
                        component: Vue.component('UserAggregateModeration', {
                            render: function render(h) {
                                if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                                if (globalData.user.isRoleAdmin) return h(AdminCatalogAggregateModeration);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                            title: 'sidebar.aggregateModeration',
                        },
                        children: [
                            {
                                path: ':id',
                                name: 'AggregateModerationDetails',
                                component: AdminCatalogAggregateModerationDetails,
                                meta: {
                                    title: 'aggregateDetails',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                        ],
                    },
                    {
                        path: 'import-moderation',
                        name: 'ImportModeration',
                        component: Vue.component('UserImportModeration', {
                            render: function render(h) {
                                if (this.$route.params.id) return h(LayoutBlank);
                                if (globalData.user.isRoleAdmin) return h(AdminCatalogImportModeration);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                            title: 'sidebar.importModeration',
                        },
                        children: [
                            {
                                path: ':id',
                                name: 'ImportModerationDetails',
                                component: AdminCatalogImportModerationDetails,
                                meta: {
                                    title: 'aggregateDetails',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                        ],
                    },
                    {
                        path: 'offers-moderation',
                        name: 'OffersModeration',
                        component: Vue.component('UserOffersModeration', {
                            render: function render(h) {
                                if (this.$route.params.id) return h(LayoutBlank);
                                if (globalData.user.isRoleAdmin) return h(AdminCatalogOffersModeration);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                            title: 'sidebar.offersModeration',
                        },
                        children: [
                            {
                                path: ':id',
                                name: 'OffersModerationDetails',
                                component: AdminCatalogOffersModerationDetails,
                                meta: {
                                    title: 'aggregateDetails',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'users',
                name: 'Users',
                component: Vue.component('Users', {
                    render: function render(h) {
                        if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                        if (globalData.user.isRoleAdmin) return h(AdminUsers);
                        return h(LayoutBlank);
                    },
                }),
                meta: {
                    title: 'users',
                    roles: [Role.ADMIN, Role.SUPERADMIN],
                },
                children: [
                    {
                        path: ':id(\\d+):sep(-)?:slug(.*)?',
                        name: 'UsersDetails',
                        component: Vue.component('UserUsersDetails', {
                            render: function render(h) {
                                if (globalData.user.isRoleAdmin) return h(AdminUsersDetails);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'pagesDetails',
                            roles: [Role.ADVERTISER, Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                ],
            },
            {
                path: 'offers',
                name: 'Offers',
                component: Vue.component('Offers', {
                    render: function render(h) {
                        if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                        if (globalData.user.isRoleAdmin) return h(AdminOffers);
                        return h(LayoutBlank);
                    },
                }),
                meta: {
                    title: 'offerFinder',
                    roles: [Role.ADMIN, Role.SUPERADMIN],
                },
                children: [
                    {
                        path: ':id(\\d+):sep(-)?:slug(.*)?',
                        name: 'OffersDetails',
                        component: Vue.component('UserOffersDetails', {
                            render: function render(h) {
                                if (globalData.user.isRoleAdmin) return h(AdminOffersDetails);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'pagesDetails',
                            roles: [Role.ADVERTISER, Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                ],
            },
            {
                path: 'producer-products',
                name: 'ProducerProducts',
                component: LayoutBlank,
                redirect: {
                    name: 'ProducerProductsProducts',
                },
                children: [
                    {
                        path: 'products',
                        name: 'ProducerProductsProducts',
                        component: Vue.component('UserProducerProductsProducts', {
                            render: function render(h) {
                                if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                                if (globalData.user.isRoleAdmin) return h(AdminProducerProductsProducts);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'producerProductsSearch',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                        children: [
                            {
                                path: ':id',
                                name: 'ProducerProductsProductsDetails',
                                component: AdminProducerProductsProductsDetails,
                                meta: {
                                    title: 'productDetails',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                        ],
                    },
                    {
                        path: 'import',
                        name: 'ProducerProductsImport',
                        component: Vue.component('ProducerProductsImport', {
                            render: function render(h) {
                                if (globalData.user.isRoleAdmin) return h(AdminProducerProductsImport);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'producerProductsImport',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                ],
            },
            {
                path: 'transactions',
                name: 'Transactions',
                component: LayoutBlank,
                redirect: {
                    name: 'TransactionsImport',
                },
                meta: {
                    title: 'transactions2',
                    roles: [Role.ADMIN, Role.SUPERADMIN],
                },
                children: [
                    {
                        path: 'import',
                        name: 'TransactionsImport',
                        component: AdminTransactionsImport,
                        meta: {
                            title: 'transactionsImport',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'validation',
                        name: 'TransactionsValidation',
                        component: AdminTransactionsValidation,
                        meta: {
                            title: 'transactionValidation',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'correction',
                        name: 'TransactionsCorrection',
                        component: AdminTransactionsCorrection,
                        meta: {
                            title: 'transactionCorrection',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                ],
            },
            {
                path: 'finance',
                name: 'AdminFinance',
                component: LayoutBlank,
                redirect: {
                    name: 'AdminFinanceSettlements',
                },
                meta: {
                    roles: [Role.ADMIN, Role.SUPERADMIN],
                },
                children: [
                    {
                        path: 'settlements',
                        name: 'AdminFinanceSettlements',
                        component: LayoutBlank,
                        redirect: {
                            name: 'AdminFinanceSettlementsPublishers',
                        },
                        meta: {
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                        children: [
                            {
                                path: 'publishers',
                                name: 'AdminFinanceSettlementsPublishers',
                                component: AdminFinanceSettlementsPublishers,
                                meta: {
                                    title: 'settlementsWithPublishers',
                                    roles: [Role.ADMIN, Role.SUPERADMIN],
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'products',
                name: 'Products',
                component: Vue.component('UserProducts', {
                    render: function render(h) {
                        if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                        if (globalData.user.isRoleAdmin) return h(AdminProducts);
                        return h(LayoutBlank);
                    },
                }),
                meta: {
                    title: 'sidebar.aggregateSearch',
                    roles: [Role.ADMIN, Role.SUPERADMIN],
                },
                children: [
                    {
                        path: ':id/audit',
                        name: 'ProductsItemAudit',
                        component: AdminProductsItemAudit,
                        meta: {
                            title: 'aggregateAudit',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: ':id',
                        name: 'ProductsItemShow',
                        component: AdminProductsItemShow,
                        meta: {
                            title: 'aggregateDetails',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                ],
            },
            {
                path: 'bb-affiliate-program',
                name: 'BBAffiliateProgram',
                component: WidgeterBBAffiliateProgram,
                meta: {
                    title: 'sidebar.bbAffiliateProgram',
                    roles: [Role.WIDGETER, Role.SUPERADMIN],
                },
            },
            {
                path: 'tipbox',
                name: 'Tipbox',
                component: LayoutBlank,
                meta: {
                    roles: [Role.WIDGETER, Role.ADMIN, Role.SUPERADMIN],
                    feature: 'tipbox',
                },
                redirect: {
                    name: 'TipboxTips',
                },
                children: [
                    {
                        path: 'tips',
                        name: 'TipboxTips',
                        component: Vue.component('UserTipboxTips', {
                            render: function render(h) {
                                if (globalData.user.isRoleAdmin) return h(AdminTipboxTips);
                                if (globalData.user.isRoleWidgeter) return h(WidgeterTipboxTips);
                                return h(LayoutBlank);
                            },
                        }),
                    },
                    {
                        path: 'settlements',
                        name: 'TipboxSettlements',
                        component: Vue.component('UserTipboxSettlements', {
                            render: function render(h) {
                                if (globalData.user.isRoleAdmin) return h(AdminTipboxSettlements);
                                if (globalData.user.isRoleWidgeter) return h(WidgeterTipboxSettlements);
                                return h(LayoutBlank);
                            },
                        }),
                    },
                    {
                        path: 'verification',
                        name: 'AdminTipboxVerification',
                        component: AdminTipboxVerification,
                        meta: {
                            title: 'sidebar.verification',
                            roles: [Role.ADMIN, Role.SUPERADMIN],
                        },
                    },
                    {
                        path: 'settings',
                        name: 'WidgeterTipboxSettings',
                        alias: 'activation',
                        component: Vue.component('UserTipboxSettings', {
                            render: function render(h) {
                                if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                                if (globalData.user.isRoleWidgeter) return h(WidgeterTipboxSettings);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'sidebar.tipboxSettings',
                            roles: [Role.WIDGETER],
                        },
                        children: [
                            {
                                path: ':id',
                                name: 'WidgeterTipboxSettingsEdit',
                                component: WidgeterTipboxSettingsEdit,
                                meta: {
                                    title: 'sidebar.tipboxSettings',
                                    roles: [Role.WIDGETER],
                                },
                            },
                        ],
                    },
                    {
                        path: 'link',
                        name: 'WidgeterTipboxLink',
                        component: Vue.component('UserTipboxLink', {
                            render: function render(h) {
                                if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                                if (globalData.user.isRoleWidgeter) return h(WidgeterTipboxLink);
                                return h(LayoutBlank);
                            },
                        }),
                        meta: {
                            title: 'sidebar.tipboxLink',
                            roles: [Role.WIDGETER],
                            feature: 'tipbox-landing',
                        },
                        children: [
                            {
                                path: ':id(\\d+)',
                                name: 'WidgeterTipboxLinkEdit',
                                component: WidgeterTipboxLinkEdit,
                                meta: {
                                    title: 'sidebar.tipboxLinkEdit',
                                    roles: [Role.WIDGETER],
                                    feature: 'tipbox-landing',
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'product-groups',
                name: 'ProductGroups',
                component: Vue.component('UserProductGroups', {
                    render: function render(h) {
                        if (Number.parseInt(this.$route.params.id)) return h(LayoutBlank);
                        if (this.$route.params.id === 'add') return h(LayoutBlank);
                        return h(ProducerProductGroups);
                    },
                }),
                meta: {
                    title: 'sidebar.productGroups',
                    roles: [Role.PRODUCER],
                },
                children: [
                    {
                        path: ':id(\\d+|add)',
                        name: 'ProductGroupsEdit',
                        component: ProducerProductGroupsEdit,
                        meta: {
                            title: 'sidebar.productGroupsEdit',
                            roles: [Role.PRODUCER],
                        },
                    },
                ],
            },
            {
                path: 'product-catalog',
                name: 'ProductCatalog',
                component: ProducerProductCatalog,
                meta: {
                    title: 'sidebar.productCatalog',
                    roles: [Role.PRODUCER],
                },
            },
            {
                path: 'competitive-analysis',
                name: 'CompetitiveAnalysis',
                component: ProducerCompetitiveAnalysis,
                meta: {
                    title: 'sidebar.competitiveAnalysis',
                    roles: [Role.PRODUCER],
                },
            },
            {
                path: 'plugin',
                name: 'Plugin',
                component: ProducerPlugin,
                meta: {
                    title: 'sidebar.plugin',
                    roles: [Role.PRODUCER],
                },
            },
            {
                path: 'data-export',
                name: 'DataExport',
                component: ProducerDataExport,
                meta: {
                    title: 'sidebar.dataExport',
                    roles: [Role.PRODUCER],
                },
            },

            {
                path: '*',
                component: PageNotFound,
            },
        ],
    },
    {
        path: '',
        component: LayoutBasic,
        children: [
            {
                path: 'forbidden',
                name: 'Forbidden',
                component: PageForbidden,
            },
            {
                path: '*',
                component: PageNotFound,
            },
        ],
    },
];

const router = new Router({
    mode: 'history',
    routes,
    parseQuery(query) {
        return qs.parse(query, { arrayLimit: 10000, comma: true });
    },
    stringifyQuery(query) {
        const result = qs.stringify(query, { arrayFormat: 'comma', encode: false });
        return result ? `?${result}` : '';
    },
});

router.beforeEach(hasAccessGuard.bind(router));
router.beforeEach(hasFeatureGuard.bind(router));

router.afterEach((to, from) => {
    if (from.path !== to.path) {
        apiService.abortApiRequests();

        const brand = 'BUY.BOX';
        document.title = to.meta.title ? `${i18n.t(to.meta.title)} | ${brand}` : brand;

        if (window.ga) {
            window.ga('set', 'page', to.fullPath);
            window.ga('send', 'pageview');
        }

        if (usercomService.isUserComAvailable()) usercomService.pageHit(usercomService.getUserDataFromUser(globalData.user));

        if (typeof window.fbq === 'function') window.fbq('track', 'PageView');
    }
});

export default router;

export { routes };
